import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import InboxIcon from "@material-ui/icons/MoveToInbox";
import MailIcon from "@material-ui/icons/Mail";
import { NavLink, useHistory } from "react-router-dom";
import { useData } from "../../context/DataContext";
import { Avatar, ListItemAvatar, Typography } from "@material-ui/core";
import { Dashboard, Home, PowerSettingsNew } from "@material-ui/icons";
import EqualizerIcon from "@material-ui/icons/Equalizer";
import { useAuth } from "../../context/AuthContext";
import { auth } from "../../config/Firebase";
const width = 240;

const useStyles = makeStyles((theme) => ({
  drawer: { width, flexShrink: 0 },
  drawerPaper: { width },
  toolbar: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(3),
  },
  small: {
    width: theme.spacing(3),
    height: theme.spacing(3),
  },
}));

const Sidebar = () => {
  const { values, ...data } = useData();
  const { isAuth, activeUser, logout } = useAuth();
  const classes = useStyles();
  return (
    <Drawer
      className={classes.drawer}
      variant="permanent"
      classes={{
        paper: classes.drawerPaper,
      }}
      anchor="left"
    >
      <div className={classes.toolbar} />
      <Divider />
      <List>
        <ListItem exact component={NavLink} to={`/`} button>
          <ListItemIcon>
            <Home />
          </ListItemIcon>
          <ListItemText primary={`Home`} />
        </ListItem>
        {values.map((el, index) => (
          <ListItem
            exact
            component={NavLink}
            to={`/levels/${el}`}
            button
            disabled={
              !isAuth
                ? true
                : `level_${(activeUser.currentLevel || 0) + 1}` < el
            }
            key={index}
          >
            <ListItemIcon>
              <Avatar
                style={{ background: `transparent` }}
                className={"position-relative " + classes.small}
              >
                <img src={data[el]?.icon?.[0].src} className="img" alt="" />
              </Avatar>
            </ListItemIcon>
            <ListItemText
              style={{ textTransform: `capitalize` }}
              primary={el.split("_").join(" ")}
            />
          </ListItem>
        ))}
        {activeUser.role === "admin" && (
          <ListItem exact component={NavLink} to={`/dashboard`} button>
            <ListItemIcon>
              <Dashboard />
            </ListItemIcon>
            <ListItemText primary={`Admin`} />
          </ListItem>
        )}
        {isAuth && (
          <>
            <ListItem exact component={NavLink} to={`/leaderboard`} button>
              <ListItemIcon>
                <EqualizerIcon />
              </ListItemIcon>
              <ListItemText primary={`Leaderboard`} />
            </ListItem>
            <ListItem exact component={NavLink} to={`/stats`} button>
              <ListItemIcon>
                <EqualizerIcon />
              </ListItemIcon>
              <ListItemText primary={`Stats`} />
            </ListItem>
            <ListItem onClick={logout} button>
              <ListItemIcon>
                <PowerSettingsNew />
              </ListItemIcon>
              <ListItemText primary={`Signout`} />
            </ListItem>
          </>
        )}
      </List>
      <Divider />
    </Drawer>
  );
};

export default Sidebar;
